// src/components/shared/tableProps.js
// Shared MaterialReactTable prop defaults used across all config view tables.
// Spread these into <MaterialReactTable {...sharedTableProps} ...> FIRST,
// before any page-specific props, so a page's own explicit props (density,
// custom cell renderers, sizing, etc.) still take priority when it needs
// to differ from the default look.
//
// This is the "modern table" baseline: a bordered, rounded card instead of
// a flat borderless grid, a distinct (uppercase, tinted) header so it reads
// as a header rather than just another data row, zebra striping + hover
// highlighting for scanability on long lists, and a plain (non-bordered)
// toolbar area so the card border is the only frame around the table.
export const sharedTableProps = {
  layoutMode: "grid",
  muiTablePaperProps: {
    elevation: 0,
    sx: {
      borderRadius: 3,
      border: "1px solid",
      borderColor: "divider",
      boxShadow: "0 1px 6px rgba(15, 23, 42, 0.06)",
      overflow: "hidden",
    },
  },
  muiTableHeadCellProps: {
    sx: {
      bgcolor: "#F8FAFC",
      color: "text.secondary",
      fontWeight: 700,
      fontSize: "0.75rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      borderBottom: "2px solid",
      borderColor: "divider",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      fontSize: "0.875rem",
      borderColor: "divider",
    },
  },
  muiTableBodyRowProps: {
    sx: {
      "&:nth-of-type(even)": { bgcolor: "#FAFBFC" },
      "&:hover": { bgcolor: "action.hover" },
      "&:last-of-type td": { borderBottom: "none" },
    },
  },
  muiTopToolbarProps: {
    sx: { bgcolor: "transparent", boxShadow: "none" },
  },
  muiBottomToolbarProps: {
    sx: { bgcolor: "transparent", boxShadow: "none" },
  },
  enableStickyHeader: true,
  enableStickyFooter: true,
  autoResetPageIndex: false,
};
